import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
export class ApplicationFormalitiesResource extends BaseCamelCasedResource {
    pk() {
        return `${this.applicationNumber}::${this.key}`;
    }
}
ApplicationFormalitiesResource.urlRoot = legacyApiResourceUrl("FormalitiesCheck/GetFormalitiesCheckpoints");
//# sourceMappingURL=ApplicationFormalitiesResource.js.map